import { Flow_0_0_2 } from '@flexus/core';
import { jobInfoNode } from '../reusable/JOB_INFO_NODE';
import { voucherInfoNode } from '../reusable/VOUCHER_INFO_NODE';
import { MUL_183 } from './MUL_183';
import { setActionPanelItems } from '../../../../app-shell-features';
import { REWORK_NODE } from '../reusable/REWORK_NODE';
import { requestQANode } from '../reusable/REQUEST_QA_NODE';
import { resolvedProblemNode } from '../reusable/RESOLVED_PROBLEM_NODE';
import { GENERIC_BFTSMAPPER } from '../reusable/GENERIC_BFTSMAPPER';

export const MUL_179: Flow_0_0_2 = {
	id: '179',
	name: 'request_for_qa',
	itemType: 'flow',
	actionPanel: instance => setActionPanelItems(instance, ['job-card', 'notes', 'documents']),
	header: {
		title: 'Request for QA',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Request for QA'
		},
		viewRoles: {
			0: 'Request for QA'
		}
	},
	serverCalls: {
		files: {
			serviceVariable: 'mulService',
			functionName: 'getAllJobFiles',
			responseSlice: 'payload',
			errorMessage: 'Could not get files from server!'
		},
		voucher: {
			serviceVariable: 'mulService',
			functionName: 'getVoucherInfo',
			responseSlice: 'payload',
			errorMessage: 'Could not get voucher from server!'
		}
	},
	startNode: 'voucherData',
	nodes: {
		voucherData: {
			...voucherInfoNode(179, 180)
		},
		jobInformation: {
			showTabs: true,
			...jobInfoNode(179)
		},
		requestQA: {
			...requestQANode(179)
		},
		resolvedProblem: {
			...resolvedProblemNode()
		},
		rework: {
			...REWORK_NODE
		},
		submissionSuccess: {
			component: 'FLXSuccessTickComponent',
			navs: []
		}
	},
	bigFormToStoreMapper: {
		...GENERIC_BFTSMAPPER
	}
};
